import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface CCEInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function CCEInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: CCEInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Cash & Cash Equivalents"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}

